<template>
  <div class="container">
    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="active"
        title-active-color="#d62f2f"
        line-width="30px"
        line-height="5px"
        @change="typeClick"
      >
        <van-tab title="我的名片"></van-tab>
        <van-tab title="名片夹"></van-tab>
      </van-tabs>
    </div>
    <div class="listBox" v-if="active == 0">
      <div v-if="cardlist != null && cardlist.length > 0">
        <div
          class="listItem"
          v-for="(item, index) in cardlist"
          :key="index"
          @click="showCard(item.ContactID)"
        >
          <img src="../../../static/images/index/nc_bg01.png" />
          <div class="topBox">
            <div class="leftBox">
              <div class="name">{{ item.ContactName }}</div>
              <div class="job">{{ item.Duty }}</div>
            </div>
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
          </div>
          <div class="bottomBox">
            <div class="sitem">
              <span class="iconfont icon-phone"></span>
              <span>{{ item.Mobile }}</span>
            </div>
            <div class="sitem">
              <span class="iconfont icon-email-fill"></span>
              <span>{{ item.Email }}</span>
            </div>
            <div class="company">{{ item.CompanyName }}</div>
            <div class="address">{{ item.Address }}</div>
          </div>
        </div>
        <div class="addBtn">
          <router-link to="/addPostcard">
            <span class="iconfont icon-add"></span>
            <span>新增名片</span>
          </router-link>
        </div>
      </div>
      <div class="noDataBox" v-else>
        <div class="iconfont icon-kong"></div>
        <div class="">暂无名片，赶紧创建专属名片吧。</div>
        <div class="createBtn">
          <router-link to="/addPostcard">创建个人名片</router-link>
        </div>
      </div>
    </div>

    <div class="listBox" v-if="active == 1">
      <div class="totalBox">
        <div class="total">
          <div v-if="total">
            共 <span>{{ total }}</span> 张名片
          </div>
        </div>
        <div class="query-box" v-if="searchShow">
          <span class="iconfont icon-search"></span>
          <input
            type="text"
            v-model="keyword"
            @blur="searchHandle"
            @keyup.enter="searchHandle"
          />
          <div class="clear" @click.stop="clearClick">
            <span class="iconfont icon-clear"></span>
          </div>
        </div>
        <div class="query-box stop" @click.stop="focusClick" v-else>
          <span class="iconfont icon-search"></span>
        </div>
      </div>
      <van-list
        v-if="list != null && list.length > 0"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div
          class="holderItem"
          v-for="(item, index) in list"
          :key="index"
          @click="toDetail(item.ContactID)"
        >
          <img src="../../../static/images/index/nc_bg03.png" />
          <div class="leftBox">
            <div class="name">{{ item.ContactName }}</div>
            <div class="job">{{ item.Duty }}</div>
            <div class="address">{{ item.CompanyName }}</div>
          </div>
          <van-image
            fit="cover"
            :src="item.Photo"
            round
            error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
          ></van-image>
        </div>
      </van-list>
      <div class="noDataBox" v-else>
        <div class="iconfont icon-kong"></div>
        <div class="">暂无名片，赶紧去保存他人名片吧。</div>
      </div>
    </div>

    <van-overlay :show="show">
      <div class="posterImg">
        <img
          src="../../../static/images/index/close.png"
          class="closeImg"
          @click.stop="closeCodeClick"
        />
        <div ref="imageDom">
          <div class="listItem">
            <img src="../../../static/images/index/nc_bg01.png" />
            <div class="topBox">
              <div class="leftBox">
                <div class="name">{{ info.ContactName }}</div>
                <div class="job">{{ info.Duty }}</div>
              </div>
              <van-image
                fit="cover"
                :src="base64ImgData"
                round
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              ></van-image>
            </div>
            <div class="bottomBox">
              <div class="sitem">
                <span class="iconfont icon-phone"></span>
                <span>{{ info.Mobile }}</span>
              </div>
              <div class="sitem">
                <span class="iconfont icon-email-fill"></span>
                <span>{{ info.Email }}</span>
              </div>
              <div class="company">{{ info.CompanyName }}</div>
              <div class="address">{{ info.FullAddress }}</div>
            </div>
          </div>
          <div class="codeBox">
            <div class="codeTitle" v-if="info.MainSupply">业务范围</div>
            <div class="codeContent" v-if="info.MainSupply">
              {{ info.MainSupply }}
            </div>
            <div class="ercodeBox">
              <div class="ercode" ref="qrCodeUrl"></div>
              <div>扫码查看相关详情</div>
            </div>
          </div>
        </div>
        <img :src="imgcode" v-if="imgcode" class="saveImg" />
        <div class="bottomOperate">
          <router-link
            class="opeItem"
            :to="{ name: 'modifyPostcard', query: { id: info.ContactID } }"
          >
            <div class="iconfont icon-editor"></div>
            <div>编辑名片</div>
          </router-link>
          <div class="opeItem" @click="showLayer = true">
            <div class="iconfont icon-share1"></div>
            <div>转发</div>
          </div>
          <div class="opeItem" @click="generatePosterImage">
            <div class="iconfont icon-xiazai"></div>
            <div>保存名片</div>
          </div>
        </div>
      </div>
    </van-overlay>

    <!--转发-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <!--遮罩层-->
    <van-overlay
      v-show="showLayer"
      @click="showLayer = false"
      style="z-index: 14"
    ></van-overlay>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { getShareData } from "@/utils/share";
import { converPhotoBase64 } from "@/api/product";
import {
  loginMemberBusinessContactList,
  businessContactFoldersList,
  memberBusinessContactInfo,
} from "@/api/index";
import { Tab, Tabs, Image, List, Overlay, Toast } from "vant";
export default {
  name: "myPostcard",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-image": Image,
    "van-list": List,
    "van-overlay": Overlay,
    Toast,
  },
  data() {
    return {
      active: 0,
      keyword: "",
      focus: false,
      searchShow: false,

      cardlist: [],

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      show: false,
      showLayer: false,
      info: "",
      codeUrl: process.env.VUE_APP_BASE_HREF + "/receivePostcard?id=", //二维码链接
      imgcode: "", //生成的二维码图片
      base64ImgData: "",
    };
  },
  methods: {
    //搜索
    searchHandle() {
      this.pageIndex = 1;
      this.list = [];
      this.getListHandle();
    },

    //名片弹窗
    showCard(id) {
      this.show = true;
      this.getDetail(id);
    },

    //关闭弹窗
    closeCodeClick() {
      this.show = false;
    },

    //获取名片详情
    getDetail(id) {
      var that = this;
      var data = {
        ContactID: id,
      };
      memberBusinessContactInfo(data).then((res) => {
        that.info = res.Data;
        that.codeUrl =
          process.env.VUE_APP_BASE_HREF +
          "/receivePostcard?id=" +
          res.Data.ContactID;
        that.pictureFormat(res.Data.Photo);
        that.qrcode(that.codeUrl);
        that.$refs.qrCodeUrl = "";
        getShareData(
          that.codeUrl,
          res.Data.ContactName + "的名片，快来看看呀",
          "",
          res.Data.ShareImg
        );
      });
    },

    //整张海报图片生成
    generatePosterImage() {
      var that = this;
      html2canvas(that.$refs.imageDom, {
        backgroundColor: "transparent", //设置透明背景
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, //允许跨域图片
        taintTest: false, //是否在渲染前测试图片
      }).then((canvas) => {
        let imgUrl = canvas.toDataURL("image/png"); // 转成图片，生成图片地址
        that.imgcode = imgUrl;
        Toast("长按保存图片");
      });
    },

    // 生成二维码
    qrcode(url) {
      let qrcode = new QRCode(this.$refs.qrCodeUrl, {
        width: 98, // 宽度
        height: 98, // 高度
        background: "#ffffff", // 背景色
        foreground: "#000000", // 前景色
        text: url, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      });
    },

    //转换图片格式
    async pictureFormat(photo) {
      var that = this;
      var data = {
        Photo: photo,
      };
      await converPhotoBase64(data).then((res) => {
        that.base64ImgData = res.Data;
      });
    },

    //点击查询聚焦
    focusClick() {
      this.searchShow = true;
      this.focus = true;
    },

    //清空点击
    clearClick: function () {
      this.keyword = "";
      this.list = [];
      this.pageIndex = 1;
      this.getListHandle();
    },

    //tab切换
    typeClick(name) {
      this.active = name;
      if (this.active == 0) {
        this.getloginMemberBusinessContactList();
      } else {
        this.pageIndex = 1;
        this.list = [];
        this.loading = true;
        if (this.loading) {
          this.getListHandle();
        }
      }
    },

    //获取我的名片列表
    getloginMemberBusinessContactList() {
      loginMemberBusinessContactList().then((res) => {
        this.cardlist = res.Data.List;
      });
    },

    //获取名片夹
    getListHandle() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      businessContactFoldersList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //跳转名片详情
    toDetail(id) {
      this.$router.push({ path: "/postcardDetail", query: { id: id } });
    },
  },
  mounted() {
    this.getloginMemberBusinessContactList();
  },
};
</script>
<style lang="less" scoped>
.classifyNav {
  font-size: 14px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 0;
  font-size: 14px;
  padding: 0 60px;
  /deep/.van-tab--active {
    font-weight: bold;
  }
  /deep/.van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none;
  }
}

.listBox {
  margin: 18px 13px;

  .createBtn {
    width: 124px;
    height: 35px;
    line-height: 35px;
    background: rgba(214, 47, 47, 0);
    border: 1px solid #d62f2f;
    border-radius: 17px;
    font-size: 13px;
    text-align: center;
    margin: 26px auto;
    a {
      color: #d62f2f;
    }
  }
  .addBtn {
    width: 110px;
    height: 35px;
    line-height: 35px;
    background: rgba(214, 47, 47, 0);
    border: 1px solid #d62f2f;
    border-radius: 17px;
    font-size: 13px;
    text-align: center;
    margin: 20px auto;
    span {
      color: #d62f2f;
    }
    .iconfont {
      font-size: 12px;
      margin-right: 6px;
    }
  }
  .totalBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    .total {
      font-size: 11px;
      span {
        font-weight: bold;
      }
    }
    .query-box {
      width: 175px;
      padding: 0 0 0 10px;
      height: 35px;
      position: relative;
      background: #f5f5f5;
      border-radius: 17px;
      display: flex;
      align-items: center;
      .clear {
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translate(0, -50%);
        width: 25px;
        height: 35px;
        display: flex;
        align-items: center;
        .iconfont {
          color: #cccccc;
          font-size: 16px;
          line-height: 16px;
        }
      }
      input {
        width: 120px;
        margin-left: 10px;
        color: #333333;
        font-size: 12px;
        border: none;
        background-color: transparent;
      }
      .icon-search {
        color: #cccccc;
        font-size: 16px;
      }
    }
    .stop {
      width: 35px;
      padding: 0;
      justify-content: center;
    }
  }
  .holderItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 350px;
    height: 118px;
    margin-bottom: 16px;
    img {
      width: 350px;
      height: 118px;
      position: absolute;
      z-index: -1;
    }
    .leftBox {
      margin-left: 25px;
      .name {
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }
      .job {
        color: #999;
        font-size: 13px;
        margin-top: 9px;
      }
      .address {
        width: 230px;
        color: #999;
        font-size: 13px;
      }
    }
    .van-image {
      display: block;
      width: 70px;
      height: 70px;
      margin-right: 25px;
    }
  }
}
.listItem {
  position: relative;
  width: 350px;
  height: 230px;
  margin-bottom: 16px;
  img {
    width: 350px;
    height: 230px;
    position: absolute;
    z-index: -1;
  }
  .topBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px 25px;
    .leftBox {
      margin-top: 32px;
      .name {
        font-size: 25px;
        color: #333;
        font-weight: bold;
      }
      .job {
        font-size: 13px;
        font-weight: 400;
        color: #333;
        margin-top: 6px;
        margin-bottom: 12px;
      }
    }
    .van-image {
      display: block;
      width: 70px;
      height: 70px;
      margin-top: 28px;
    }
  }
  .bottomBox {
    margin: 0px 25px;
    .sitem {
      color: #333;
      font-size: 13px;
      margin-bottom: 8px;
      .iconfont {
        font-size: 12px;
        color: #5e8ae3;
        margin-right: 12px;
      }
    }
    .company {
      font-size: 15px;
      color: #333;
      font-weight: bold;
      margin-top: 10px;
      margin-bottom: 4px;
    }
    .address {
      font-size: 13px;
      color: #333;
      font-weight: 400;
    }
  }
}
.posterImg {
  padding: 8px 12px;
  .codeBox {
    position: relative;
    z-index: -2;
    margin-top: -34px;
    background-color: #5e8ae3;
    border-radius: 0px 0px 20px 20px;
    color: #fff;
    font-size: 12px;
    padding: 40px 23px 25px;
    .codeTitle {
      font-size: 12px;
      font-weight: bold;
    }
    .codeContent {
      width: 304px;
      text-align: justify;
      margin-top: 8px;
      padding-bottom: 18px;
      border-bottom: 1px solid #ddd;
    }
    .ercodeBox {
      padding-top: 13px;
      text-align: center;
      .ercode {
        display: inline-block;
        /deep/img {
          width: 98px;
          height: 98px;
          background-color: #fff; //设置白色背景色
          padding: 6px; // 利用padding的特性，挤出白边
          box-sizing: border-box;
        }
      }
    }
  }
  .closeImg {
    width: 27px;
    height: 27px;
    margin-left: 90%;
  }

  .bottomOperate {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 11px;
    background-color: #fff;
    .opeItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #333;
      .iconfont {
        font-size: 18px;
        margin-bottom: 4px;
      }
    }
  }
  .saveImg {
    position: absolute;
    z-index: 12;
    top: 54px;
    left: 12px;
    width: 350px;
    height: auto;
    border-radius: 5px;
  }
}
</style>
